export const CREATE_SALARY_DETAIL = "CREATE_SALARY_DETAIL";
export const FETCH_SALARY_DETAIL = "FETCH_SALARY_DETAIL";
export const EDIT_SALARY_DETAIL = "EDIT_SALARY_DETAIL";
